import { Modal } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { projectLogoLight, projectPrimaryColor } from "../../generalConfigs";
import { Spinner } from "react-bootstrap";
import validator from "validator";
import { MdOutlineEmail } from "react-icons/md";
import useAuth from "../../hooks/useAuth";

export default function ForgotPassword() {
  const [emailValue, setEmailValue] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isUserFinished, setIsUserFinished] = useState(false);
  const history = useHistory();
  const { doForgotPassword } = useAuth();
  const { isAuthenticated } = useAuth();

  if (isAuthenticated()) {
    history.push("/dashboard");
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsloading(true);

    if (validator.isEmail(emailValue)) {
      const sentMailResponse = await doForgotPassword(emailValue);
      if (sentMailResponse) {
        if (sentMailResponse.status === 1) {
          setIsUserFinished(true);
          setErrorMsg("Email enviado");
          setIsloading(false);
        } else {
          setErrorMsg(
            "E-mail não reconhecido, em caso de problemas entre em contato conosco"
          );
          setIsloading(false);
        }
      } else {
        setErrorMsg(
          "Ocorreu um erro desconhecido, por favor, tente novamente."
        );
        setIsloading(false);
      }
    } else {
      setErrorMsg("Verifique o email inserido e tente novamente.");
      setIsloading(false);
    }
  };

  if (isUserFinished) {
    return emailSentSuccessfully();
  }

  return (
    <Modal size="lg" fullscreen={true} show={true}>
      <div className="bg-dark">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 shadow-lg">
              <div className="hero-wrap d-flex align-items-center rounded-3 rounded-end-0 h-100">
                <div className="hero-mask opacity-9 bg-primary" />
                <div className="hero-bg hero-bg-scroll" />
                <div className="hero-content mx-auto w-100 h-100 d-flex flex-column">
                  <div className="row g-0">
                    <div className="col-11 col-lg-10 mx-auto">
                      <div className="mt-3">{projectLogoLight}</div>
                    </div>
                  </div>
                  <div className={isMobile ? "row g-0 my-3" : "row g-0 my-4"}>
                    <div className="col-11 col-lg-10 mx-auto">
                      <h1 className="text-11" style={{ color: "#e0e0e0" }}>
                        <span className="markText-animation">Sem</span>{" "}
                        problemas
                      </h1>
                      <p
                        className="text-5 lh-base mb-4"
                        style={{ color: "#e0e0e0" }}
                      >
                        Insira seu email e te enviaremos um link de recuperação
                        de senha.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-6 shadow-lg d-flex align-items-center rounded-3 rounded-start-0"
              style={{
                backgroundColor: "white",
                borderRadius: 10,
              }}
            >
              {isLoading ? (
                loadingSkeleton()
              ) : (
                <div className="container my-auto py-4">
                  <div className="row">
                    <div className="col-11 col-lg-10 mx-auto">
                      <h3 className="text-black text-center mb-3 ">
                        Esqueci minha senha
                      </h3>

                      <form className="form" onSubmit={handleSubmit}>
                        <div className="mb-3">
                          <label className="form-label text-black">
                            E-mail
                          </label>
                          <input
                            type="email"
                            value={emailValue}
                            onChange={(e) => setEmailValue(e.target.value)}
                            className="form-control"
                            required
                            minLength={7}
                            placeholder="Insira seu e-mail"
                          />
                        </div>

                        <div className="d-grid my-4 d-flex flex-column align-items-center">
                          {errorMsg !== "" && (
                            <span
                              className="my-2"
                              style={{
                                color: "red",
                                textAlign: "center",
                              }}
                            >
                              {errorMsg}
                            </span>
                          )}

                          <button
                            className="btn btn-primary"
                            style={{
                              borderRadius: 10,
                              width: "50%",
                              backgroundColor: projectPrimaryColor,
                            }}
                            type="submit"
                          >
                            Enviar
                          </button>
                        </div>
                      </form>

                      <p className="text-2 text-center text-black mb-0">
                        Lembrou da senha?
                        <span className="mx-1" href="/">
                          <Link to="/login">Login</Link>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

const loadingSkeleton = () => {
  return (
    <div className="container my-auto py-4">
      <div className="row">
        <div className="col-11 col-lg-10 mx-auto">
          <h3
            className="text-black text-center mb-3"
            style={{ minHeight: "20vh" }}
          >
            <Spinner animation="border" style={{ marginTop: "20%" }} />
          </h3>
        </div>
      </div>
    </div>
  );
};

const emailSentSuccessfully = () => {
  return (
    <Modal size="lg" fullscreen={true} show={true}>
      <div className="bg-dark">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 shadow-lg">
              <div className="hero-wrap d-flex align-items-center rounded-3 rounded-end-0 h-100">
                <div className="hero-mask opacity-9 bg-primary" />
                <div className="hero-bg hero-bg-scroll" />
                <div className="hero-content mx-auto w-100 h-100 d-flex flex-column">
                  <div className="row g-0">
                    <div className="col-11 col-lg-10 mx-auto">
                      <div className="mt-3">{projectLogoLight}</div>
                    </div>
                  </div>
                  <div className={isMobile ? "row g-0 my-3" : "row g-0 my-4"}>
                    <div className="col-11 col-lg-10 mx-auto">
                      <h1 className="text-11" style={{ color: "#e0e0e0" }}>
                        Quase <span className="markText-animation">Lá!</span>
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-6 shadow-lg d-flex align-items-center rounded-3 rounded-start-0"
              style={{
                backgroundColor: "white",
                borderRadius: 10,
              }}
            >
              <div className="container my-auto py-4">
                <div className="row">
                  <div className="col-11 col-lg-10 mx-auto">
                    <center>
                      <MdOutlineEmail size={28} />
                    </center>
                    <h3 className="text-black text-center">
                      Verifique seu e-mail.
                    </h3>
                    <span className="mg-t-20">
                      Enviamos um link para te auxiliar em sua troca de senha,
                      caso não encontre, verifique em sua caixa de spam.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
